import { keyframes } from '@emotion/react';
import * as RadixToast from '@radix-ui/react-toast';
import { colors } from '@toilet-paper-games/ui';
import { useState } from 'react';

export enum ToastIntent {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

export interface ToastProps {
  title: string;
  description?: string;
  action?: {
    text: string;
    onClick: () => void;
  };
  duration?: number;
  intent?: ToastIntent;
}

// TODO: Move to styles
const toastIntentColor = {
  [ToastIntent.INFO]: colors.primary,
  [ToastIntent.SUCCESS]: colors.success,
  [ToastIntent.WARNING]: colors.warning,
  [ToastIntent.ERROR]: colors.danger,
};

export const Toast = (props: ToastProps) => {
  const { title, description, intent = ToastIntent.INFO, duration = 3_000 } = props;

  const [open, setOpen] = useState(true);

  return (
    <RadixToast.Root
      open={open}
      onOpenChange={setOpen}
      duration={duration}
      css={{
        color: 'white',
        backgroundColor: toastIntentColor[intent],
        borderRadius: '6px',
        boxShadow:
          'hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px',
        padding: '15px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        "&[data-state='open']": {
          animation: `${slideIn} 150ms cubic-bezier(0.16, 1, 0.3, 1)`,
        },
        "&[data-state='closed']": { animation: `${hide} 100ms ease-in` },
        "&[data-swipe='move']": {
          transform: 'translateX(var(--radix-toast-swipe-move-x))',
        },
        "&[data-swipe='cancel']": {
          transform: 'translateX(0)',
          transition: 'transform 200ms ease-out',
        },
        "&[data-swipe='end']": { animation: `${swipeOut} 100ms ease-out` },
      }}
    >
      <RadixToast.Title>{title}</RadixToast.Title>
      <RadixToast.Description>{description}</RadixToast.Description>
    </RadixToast.Root>
  );
};

const hide = keyframes({
  from: { opacity: 1 },
  to: { opacity: 0 },
});

const slideIn = keyframes({
  from: { transform: 'translateX(calc(100% + var(--viewport-padding)))' },
  to: { transform: 'translateX(0)' },
});

const swipeOut = keyframes({
  from: { transform: 'translateX(var(--radix-toast-swipe-end-x))' },
  to: { transform: 'translateX(calc(100% + var(--viewport-padding)))' },
});
